import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'
import { Modal } from 'bootstrap'

const MODAL_ID = '#boxberry-cities-modal'

export default class extends Controller {
  static targets = ['boxberryCodeField']
  static values = {
    pickPointPath: String,
  }

  initialize() {
    this.modal = new Modal(MODAL_ID)
    this.openModal = this.openModal.bind(this)
    this.handlePickPointClick = this.handlePickPointClick.bind(this)
  }

  connect() {
    document.addEventListener(
      'boxberry:point-picked',
      this.handlePickPointClick
    )
    this.modalEl.addEventListener('turbo:before-fetch-response', this.openModal)
  }

  disconnect() {
    document.removeEventListener(
      'boxberry:point-picked',
      this.handlePickPointClick
    )
    this.modalEl.removeEventListener(
      'turbo:before-fetch-response',
      this.openModal
    )
  }

  openModal() {
    this.modal.show()
  }

  handlePickPointClick({ detail: { point_code } }) {
    get(this.pickPointPathValue, {
      query: { point_code },
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    }).then((response) => {
      if (response.ok) {
        // Update the (not yet declared) boxberry service point code
        // This will let us offer Boxberry's deliver to pick-up counter rates & print the corresponding shipping labels
        this.boxberryCodeFieldTarget.value = point_code
      }
    })
  }

  get modalEl() {
    return document.querySelector(MODAL_ID)
  }
}
